import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Role } from '../enums/role';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class RoleCssProviderService {
  private readonly entries = new Map<Role, string>([
    [Role.Administrator, 'bg-indigo-50 text-indigo-700 ring-indigo-700/10'],
    [Role.User, 'bg-green-50 text-green-700 ring-green-600/20'],
    [Role.WarehouseManager, 'bg-purple-50 text-purple-700 ring-purple-700/10'],
    [Role.Subscriber, 'bg-blue-50 text-blue-700 ring-blue-700/10'],
    [Role.TechnicalAdmin, 'bg-amber-50 text-amber-700 ring-amber-700/10'],
    [Role.WarehouseEmployee, 'bg-gray-50 text-gray-600 ring-gray-500/10'],
  ]);

  public css(role: Role): Observable<string> {
    const result = this.entries.get(role);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The css classes for "${role}" not found.`,
      );
    }

    return of(result);
  }
}
